import { useWidgetData } from '../useWidgetData'

import { StatisticValueMetadata } from '../../../types/court/court'

export const useTotalUsersWidget = () =>
  useWidgetData<StatisticValueMetadata>('total-users')
